import { Interpolation } from "@emotion/core";
import { DarkTheme } from "../../design-tokens/media-queries";
import { grid } from "../../design-tokens/grid";
import { Fonts } from "../../design-tokens/fonts";
import { Colors } from "../../design-tokens/colors";
import { Border } from "../../design-tokens/borders";

const heading: Interpolation = {
  fontSize: "24px",
  lineHeight: "32px",
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(3),
};

const content: Interpolation = {
  fontSize: "18px",
  marginBottom: grid(4),

  ["iframe"]: {
    [DarkTheme]: {
      backgroundColor: Colors.DarkModeWhite,
      padding: grid(1),
    },
  },

  ["iframe, img"]: {
    borderRadius: Border.RadiusSm,
  },

  "> *:last-child": {
    marginBottom: "0 !important",
  },
};

const styles = {
  heading,
  content,
};

export default styles;
